module.exports = __webpack_public_path__ + "img/dexalot.0bb0657b.svg";